import { ButtonHTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';
import { colors, fonts } from 'components/styles/variables';

export interface QuickViewCtaProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string;
}

export default function QuickViewCta({ onClick, ...props }: QuickViewCtaProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <>
      <button
        className="quick-view-cta"
        onClick={onClick}
        aria-label={t('quickView.ctaButton')}
        {...props}
      >
        {t('quickView.ctaButton')}
      </button>
      <style jsx>{`
        .quick-view-cta {
          width: 140px;
          height: 36px;
          text-align: center;
          border-radius: 8px;
          font-family: ${fonts.default};
          font-weight: 600;
          font-size: 14px;
          line-height: 20px;
          letter-spacing: 0.2px;
          padding: 0 16px;
          display: flex;
          justify-content: center;
          align-items: center;
          color: ${colors.BLACK};
          border: 1px solid ${colors.G2};
          background-color: ${colors.WHITE};
          margin-right: 16px;
          display: none;
        }

        @media (hover: hover) and (pointer: fine) {
          .quick-view-cta:hover {
            background-color: ${colors.G1};
            cursor: pointer;
          }
        }

        @media (min-width: 950px) {
          .quick-view-cta {
            display: flex;
          }
        }
      `}</style>
    </>
  );
}
